import {createFileRoute} from '@tanstack/react-router';
import {DeploymentLayout} from '@/features/deploymentManagement/components/DeploymentLayout';
import {
    SystemVersionStatusTable
} from "@/features/deploymentManagement/components/Systems and Versions/SystemVersionStatusTable.tsx";

export const Route = createFileRoute('/_authed/admin/deployment-center/system-status/')({
    component: SystemStatusPage
});

function SystemStatusPage() {
    return (
            <DeploymentLayout>
                <SystemVersionStatusTable/>
            </DeploymentLayout>
    );
}